import { widgetManager } from './widgetManager/index.js'
import init from '/app/init.js'
import '/app/styles/all.scss'
import './styles.css'

init()

if (typeof window !== 'undefined') {
  window.trueengage.widgetManager = widgetManager
}
